<template>
  <div id="app">
    <main-header v-if="showHeader"></main-header>
    <router-view />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'

export default {
  name: 'App',
  components: {MainHeader},
  mounted () {
  },
  computed :{
    showHeader () {
      return !this.$route.meta.hideHeader
    }
  }
}
</script>


<style lang="stylus">
body,
html
  height: 100vh
  overflow: hidden

#app
  background: rgb(239, 239, 242)
  background: linear-gradient(180deg, rgba(239, 239, 242, 1) 0, rgba(206, 208, 217, 1) 100%)
  display: flex
  flex-direction: column
  font-family: $base-font-family
  height: 100vh
  overflow: hidden
  // min-height: 100vh
  -moz-osx-font-smoothing: grayscale
  -webkit-font-smoothing: antialiased

  .view
    flex: 1 1 0%
    // height: "calc(100% - %s)" % $header-height MAL, pero no se porque...
    height calc(100% - 86px)
    // overflow: hidden
    position: relative
    &.error
      display flex
      align-items center
      justify-content center

  canvas
    outline none
</style>
